import React from 'react'
import styled from 'styled-components'
import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import {
  componentTableProps,
  ListItemProps
} from './types'
import useWarrantyInfo from 'hooks/useWarrantyInfo'
import { SystemComponent } from 'types/SystemComponent'
import Spinner from 'components/Spinner'
import { renderWarrantyStatus } from './helpers/renderWarrantyStatus'

const ComponentListItem = ({ children, textColor, size }: ListItemProps) => {
  return <S.ComponentListItem textColor={textColor} size={size} >{children}</S.ComponentListItem>
}

const ComponentListRow = (item: SystemComponent) => {
  const {
    warrantyInfo,
    isLoaded: isWarrantyInfoLoaded,
    hasError: warrantyInfoCallFailed
  } = useWarrantyInfo(item.serialNumber, true)

  return (
    <S.ComponentTableListRow data-testid={'sysComponentRow'}>
      <ComponentListItem>
        <p>{item.description}</p>
      </ComponentListItem>
      <ComponentListItem>
        <p>{item.modelNumber}</p>
      </ComponentListItem>
      <ComponentListItem>
        {!isWarrantyInfoLoaded && (
        <Spinner variant="cell" aria-label="warranty" />
        )}
        <p>
          {isWarrantyInfoLoaded && renderWarrantyStatus(warrantyInfo?.policyStatus, warrantyInfoCallFailed)}
        </p>
      </ComponentListItem>
    </S.ComponentTableListRow>
  )
}

const ComponentList = ({ header, list }: componentTableProps) => {
  return (
    <S.ComponentTable data-testid={'sysCompontentList'}>
      <S.ComponentTableHeaderRow style={{ marginBottom: 10 }}>
        {header.map((item: string) => (
          <ComponentListItem key={item}>
            <h3>{item}</h3>
          </ComponentListItem>
        ))}
      </S.ComponentTableHeaderRow>
      <div>
        {list.map((item: SystemComponent) => (
          <ComponentListRow key={item.id} {...item} />
        ))}
      </div>
    </S.ComponentTable>
  )
}

export default ComponentList

export const S = {
  ComponentTable: styled.div`
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow: auto;
  `,
  ComponentTableHeaderRow: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 10px;

    @media ${screenSize.small} {
      height: 0px;
      overflow: hidden;
    }
  `,
  ComponentTableListRow: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 10px;

    @media ${screenSize.small} {
      flex-direction: column;
      justify-content: space-evenly;
      align-items: unset;
      margin: 1px 0px 15px 0px;
      gap: 3px
    }
  `,

  ComponentListItem: styled.div.withConfig({
    shouldForwardProp: (prop) => !['textColor', 'size'].includes(prop)
  })<{textColor?: string, size?: number}>`
    display: flex;
    flex: 1;
    width: clamp(120px, 100%, 135px);

    span {
        flex: 1;
        align-self: center;
    }
    
    p,h3 {
        width: clamp(120px, 100%, 130px);
        padding: 3px;
        text-align: left;
        margin: 0px;
        color: ${({ textColor }) => color(textColor || 'primaryText')};
        font-size: ${({ size }) => size || 16}px;
        font-family: Inter, sans-serif;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media ${screenSize.medium} {
        width: clamp(150px, 100%, 200px);
        p {
        width: clamp(150px, 100%, 200px)
        }
    }
  `
}
